import { createContext, useContext } from "react";
import { IPoliciesContext } from "./types";

export const PoliciesContext = createContext<IPoliciesContext | null>(null);

export const usePoliciesContext = () => {
  const context = useContext(PoliciesContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
